import type { ReactNode } from "react";

interface EmptyStateProps {
  icon?: string;
  title: string;
  description?: string;
  action?: ReactNode;
}

export default function EmptyState({
  icon = "ri-inbox-line",
  title,
  description,
  action,
}: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center py-20 md:py-24 px-4 text-center">
      <span className="w-16 h-16 rounded-full bg-background-900 border border-background-800 flex items-center justify-center text-foreground-500 mb-5">
        <i className={`${icon} text-3xl`}></i>
      </span>
      <h3 className="text-lg font-medium text-foreground-100">{title}</h3>
      {description && (
        <p className="mt-2 text-sm text-foreground-500 max-w-md leading-relaxed">
          {description}
        </p>
      )}
      {action && <div className="mt-6">{action}</div>}
    </div>
  );
}